/**
 * BUG-0108：分配请求卡住时不能让界面一直转圈。
 * 请求超过时限就中止并抛出可读错误，调用方负责恢复 loading。
 */
export class RequestTimeoutError extends Error {
  public constructor(public readonly timeoutMs: number) {
    super(`请求超过 ${Math.round(timeoutMs / 1000)} 秒未响应`);
  }
}

export const REQUEST_TIMEOUT_MS = 15000;

export async function withTimeout<T>(run: (signal: AbortSignal) => Promise<T>,
  timeoutMs: number = REQUEST_TIMEOUT_MS): Promise<T> {
  const controller = new AbortController();
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<never>((_resolve, reject) => {
    timer = setTimeout(() => {
      controller.abort();
      reject(new RequestTimeoutError(timeoutMs));
    }, timeoutMs);
  });
  try {
    return await Promise.race([run(controller.signal), timeout]);
  } finally {
    if (timer) clearTimeout(timer);
  }
}
